import { ViewFilterName } from '../entities/filters/enum/types/ViewFilterName';

export class EnumHelper {
  static getEnumKeyByEnumValue(myEnum: any, enumValue: string): keyof typeof ViewFilterName {
    const keys = Object.keys(myEnum).filter(x => myEnum[x] === enumValue);
    return keys[0] as keyof typeof ViewFilterName;
  }
}
